'use client';

import type { ComponentProps } from 'react';

import { CustomLink } from '@/app/_components/CustomLink';
import {
  type GiftPreview,
  rememberGiftPreview,
} from '@/app/_components/GiftCard/giftPreview';

interface GiftPreviewLinkProps extends ComponentProps<typeof CustomLink> {
  preview: Omit<GiftPreview, 'thumbnailSrc'>;
}

//* 서버 컴포넌트에서도 쓰도록 onClick 기억만 client로 분리 — 고기부 상세가 탭한 답례품으로 즉시 채워진다
export const GiftPreviewLink = ({
  preview,
  children,
  ...linkProps
}: GiftPreviewLinkProps) => (
  <CustomLink
    {...linkProps}
    onClick={(event) => {
      rememberGiftPreview({
        ...preview,
        //* readTappedThumbnail은 링크 밖 article 이미지로 폴백해 체험단 사진이 답례품 바닥에 깔릴 수 있다
        thumbnailSrc:
          event.currentTarget.querySelector('img')?.currentSrc || undefined,
      });
    }}
  >
    {children}
  </CustomLink>
);
